<template>
  <div class="layout-wrapper d-flex flex-column">
    <div class="topbar d-flex">
      <div class="brand shadow d-flex align-items-center justify-content-center">
        <Link href="/admin"><h4 class="text-light">NEW SatuData</h4></Link>
      </div>
      <nav class="flex-fill py-3 navbar navbar-expand navbar-light bg-white shadow">
        <div class="container-fluid">
          <Link class="navbar-brand" href="#">
            <Icon :icon="['fa', 'bars']" />
          </Link>
          <ul class="navbar-nav">
            <li class="nav-item">
              <Link class="nav-link active" aria-current="page" href="#">Pencarian</Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" href="#">Notifikasi</Link>
            </li>
            <li class="nav-item dropdown">
              <Link class="nav-link dropdown-toggle" @click.prevent="show_account = !show_account">Akun <Icon :icon="['fa', 'chevron-down']" /></Link>
              <ul class="dropdown-menu" :class="{ 'show': show_account }" style="right: 0;">
                <li><Link class="dropdown-item" href="#">Profil</Link></li>
                <li><Link class="dropdown-item" href="#">Pengaturan Akun</Link></li>
                <li><hr class="dropdown-divider" /></li>
                <li><Link class="dropdown-item" @click.prevent="logout">Logout</Link></li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="main-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia';

const renderActiveMenu = (pathname) => {
  document.querySelectorAll('.nav-link.active').forEach(el => {
    el.setAttribute('class', el.getAttribute('class').replace('active', '').trim());
  });
  // // cek dengan mencari link dengan posisi url saat ini
  // document.querySelectorAll('.nav-link > a[href="'+url.pathname+'"]').forEach(({ parentElement }) => {
  //   parentElement.setAttribute('class', parentElement.getAttribute('class').trim() + ' active');
  // });
  // cek semua link lalu bandingkan
  document.querySelectorAll('.nav-link > a:not([href=""])').forEach(el => {
    if(pathname.startsWith(el.getAttribute('href'))) {
      el.parentElement.setAttribute('class', el.parentElement.getAttribute('class').trim() + ' active');
    }
  });
}

export default {
  props: {
    auth: Object,
  },
  data() {
    return {
      signout: this.$inertia.form(),
      show_account: false
    }
  },
  methods: {
    logout() {
      this.signout.delete('/auth/logout');
    }
  },
  mounted() {
    renderActiveMenu(location.pathname);
  },
  created() {
    Inertia.on('start', (event) => {
      const { url } = event.detail.visit;
      renderActiveMenu(url.pathname);
    });
  }
}
</script>

<style lang="scss">
@import '../../css/bootstrap';
@import '../../css/style';
</style>
